import Const from 'constants';
import NumberHelper from 'helpers/number-helper';

function isPlayerOnDoublePosition(player) {
    return player.position.length > 1;
}

export function isPlayerOnSinglePositionByParams(params) {
    const {playerId, playersIndexedById, checkIfPlayerOnDoublePosition} = params;

    if (!checkIfPlayerOnDoublePosition) {
        return true;
    }

    return !(playerId in playersIndexedById && isPlayerOnDoublePosition(playersIndexedById[playerId]));
}

export function getPlayerUIdsByParams(params) {
    const {playerId, playersIndexedById, positionsOnly = []} = params;

    if (isPlayerOnSinglePositionByParams(params)) {
        return [playerId];
    }

    let {position} = playersIndexedById[playerId];

    if (!isEmpty(positionsOnly)) {
        position = position.filter((value) => inArray(value, positionsOnly));
    }

    return position.map((value) => playerId + Const.LP_ITEM_DELIMITER + value);
}

function getDefaultExposure(incomingType) {
    const type = incomingType.slice(-3).toLowerCase();
    if ('min' === type) {
        return Const.DEFAULT_VALUE_FOR_MIN_EXPOSURE;
    } else if ('max' === type) {
        return Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE;
    }
    throw new Error('EXPOSURE_ERR: unknown type ' + incomingType);
}

function preparePlayerUID(player) {
    let arr = [];
    if (isPlayerOnDoublePosition(player)) {
        player.position.map((pos) => {
            arr.push(player.playerId + Const.LP_ITEM_DELIMITER + pos);
        });
    } else {
        arr.push(player.playerId);
    }
    return arr;
}

function preparePlayerExposure(player, incomingType, value, mode) {
    let exposure = {
        playerId: player.playerId,
    };

    const type = incomingType.slice(-3).toLowerCase();

    if ('min' === type) {
        exposure.exposureMin = value;
        if (value > player.getPropValueOfMode('exposureMax', mode)) {
            exposure.exposureMax = getDefaultExposure('max');
        }
    } else if ('max' === type) {
        exposure.exposureMax = value;
        if (value < player.getPropValueOfMode('exposureMin', mode)) {
            exposure.exposureMin = getDefaultExposure('min');
        }
    }

    return exposure;
}

function preparePlayersExposure(playersList, type, rawValue, playerMode = Const.DEFAULT_MODE) {
    const value = NumberHelper.prepareInt(rawValue, getDefaultExposure(type))
        .limitByRange(getDefaultExposure('min'), getDefaultExposure('max'), getDefaultExposure(type))
        .get();

    const result = [];
    for (let key in playersList) {
        const playerExposure = preparePlayerExposure(playersList[key], type, value, playerMode);
        playerExposure.mode = playerMode;
        result.push(playerExposure);
    }

    return result;
}

function calcSympathyPoints(points, sympathyPercent) {
    let val = parseFloat(points);
    if (sympathyPercent !== 0) {
        val = val + (val / 100) * sympathyPercent;
    }
    return val;
}

function isPlayerOnPosition(player, positionNames) {
    const playerPositionNames = player.positionName.split('/');
    for (let positionName of playerPositionNames) {
        if (inArray(positionName, positionNames)) {
            return true;
        }
    }
    return false;
}

function getOpponentsDelimiterByPlayer(player) {
    return player.isHome ? 'vs' : '@';
}

function setGameDetailsToPlayer(game, player) {
    player.gameInfo = game.gameInfo;
    player.gameDate = game.gameDate;
    player.gameTime = game.gameTime;
}

function createCsvPlayer(playerId, player) {
    return {
        id: playerId,
        name: player.name,
        positionName: player.positionInLineup,
    };
}

function adjustCsvPlayerPositionName(csvPlayers, positionsMap) {
    return csvPlayers.map((csvPlayer) => {
        const adjustedCsvPlayer = cp(csvPlayer);

        if (csvPlayer.positionName in positionsMap) {
            const positionMap = positionsMap[adjustedCsvPlayer.positionName];

            for (let positionName in positionMap) {
                if (positionMap[positionName]) {
                    continue;
                }

                adjustedCsvPlayer.positionName = positionName;
                positionMap[positionName] = true;

                break;
            }
        }

        return adjustedCsvPlayer;
    });
}

function getPlayerNameSlug(playerName) {
    return playerName
        .split(' ')
        .filter((name) => name.length > 0)
        .join('_')
        .toLowerCase();
}

export {
    getDefaultExposure,
    preparePlayerUID,
    preparePlayersExposure,
    calcSympathyPoints,
    isPlayerOnDoublePosition,
    isPlayerOnPosition,
    getOpponentsDelimiterByPlayer,
    setGameDetailsToPlayer,
    createCsvPlayer,
    adjustCsvPlayerPositionName,
    getPlayerNameSlug,
};
